import { Transition, Dialog, TransitionChild, DialogPanel, DialogTitle } from "@headlessui/react"
import useModal from "../hooks/useModal"
import { Fragment } from "react"

export default function ModalV2({ name, title = "", children, className = '', closeButton = true, onClose, ...props }) {
  const depositModal = useModal(name)
  const handleClose = onClose !== undefined ? onClose : () => depositModal.close();

  return (<Transition show={depositModal.isOpen} as={Fragment}>
    <Dialog as="div" className="relative z-50" onClose={handleClose}>
      <TransitionChild
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-black/30" />
      </TransitionChild>

      <div className="fixed inset-0 flex items-center justify-center p-4 bg-slate-900/40 modal-blur">
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <DialogPanel className={`transform overflow-hidden rounded-2xl bg-white p-6 shadow-xl transition-all ${className || ''}`}>
            {title && <DialogTitle className="text-lg font-medium text-gray-900">
              {title || 'Modal Title'}
            </DialogTitle>}
            <div className="h-full w-full">
              {children || (
                <p className="text-sm text-gray-500">
                  This is a modal content placeholder.
                </p>
              )}
            </div>
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </Transition>)
}